<template>
  <page-view class="page-invoice-search mwclg-style">
    <div slot="pageRight">
      <div class="order-search">
        <p class="title">{{ $t('menu.HistoricalRedemptionRecords') }}</p>
        <div class="flex">
          <el-form
            ref="searchForm"
            :model="searchForm"
            style="flex: 1"
            :label-width="lang == 'zh' ? '100px' : '120px'"
          >
            <el-row :gutter="16">
              <el-col :span="8">
                <el-form-item
                  :label="$t('HistoricalRedemptionRecords.ProductName')"
                >
                  <el-input
                    v-model="searchForm.ProductName"
                    size="small"
                    :placeholder="$t('InvoiceInquiry.PleaseEnter')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$t('HistoricalRedemptionRecords.OrderNumber')"
                >
                  <el-input
                    v-model="searchForm.OrderNo"
                    size="small"
                    :placeholder="$t('InvoiceInquiry.PleaseEnter')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$t('HistoricalRedemptionRecords.OrderStatus')"
                >
                  <el-select
                    v-model="searchForm.Status"
                    clearable
                    size="small"
                    :placeholder="$t('InvoiceInquiry.PleaseSelect')"
                  >
                    <el-option
                      :value="0"
                      :label="$t('HistoricalRedemptionRecords.Canceled')"
                    >
                      {{ $t('HistoricalRedemptionRecords.Canceled') }}
                    </el-option>
                    <el-option
                      :value="1"
                      :label="$t('HistoricalRedemptionRecords.Submitted')"
                    >
                      {{ $t('HistoricalRedemptionRecords.Submitted') }}
                    </el-option>
                    <el-option
                      :value="2"
                      :label="$t('HistoricalRedemptionRecords.Processing')"
                    >
                      {{ $t('HistoricalRedemptionRecords.Processing') }}
                    </el-option>
                    <el-option
                      :value="3"
                      :label="$t('HistoricalRedemptionRecords.Finished')"
                    >
                      {{ $t('HistoricalRedemptionRecords.Finished') }}
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div style="margin: 0 22px; width: 0.5px; background: #f3f4f6"></div>
          <div style="margin-top: 10px">
            <el-button
              type="primary"
              size="small"
              icon="el-icon-search"
              :loading="pageLoading"
              @click="search(true)"
              >{{ $t('InvoiceInquiry.Inquire') }}</el-button
            >
            <el-button
              size="small"
              icon="el-icon-refresh-right"
              :loading="pageLoading"
              @click="reset()"
              >{{ $t('InvoiceInquiry.Reset') }}</el-button
            >
          </div>
        </div>
      </div>
      <div class="order-list">
        <el-table v-loading="pageLoading" :data="tableData" style="width: 100%">
          <el-table-column
            prop="OrderNo"
            :label="$t('HistoricalRedemptionRecords.OrderNumber')"
            width="130"
          >
          </el-table-column>
          <el-table-column
            prop="ProductName"
            :label="$t('HistoricalRedemptionRecords.ProductName')"
            width="130"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="ProductSpecifications"
            :label="$t('HistoricalRedemptionRecords.ProductSpecification')"
            :width="lang == 'zh' ? '130' : '180'"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="Num"
            :label="$t('HistoricalRedemptionRecords.Quantity')"
            width="100"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="UseIntegral"
            :label="$t('HistoricalRedemptionRecords.UsePoints')"
            show-overflow-tooltip
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="ContactsName"
            :label="$t('HistoricalRedemptionRecords.ContactPerson')"
            :width="lang == 'zh' ? '100' : '130'"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="ContactsPhone"
            :label="$t('HistoricalRedemptionRecords.TelephoneNumber')"
            :width="lang == 'zh' ? '130' : '150'"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="ShippingAddress"
            :label="$t('HistoricalRedemptionRecords.DeliveryAddress')"
            width="150"
            show-overflow-tooltip
          >
            <template #default="{ row }">
              <span v-if="row.CommodityType != 1">
                {{
                  (row.ShippingProvinceName || '') +
                  (row.ShippingCityName || '') +
                  (row.ShippingDistrictName || '') +
                  (row.ShippingTownShipName || '') +
                  (row.ShippingAddress || '')
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="strOrderStatus"
            :label="$t('HistoricalRedemptionRecords.OrderStatus')"
            width="100"
          >
            <template #default="{ row }">
              <span v-if="row.Status == '0'">{{
                $t('HistoricalRedemptionRecords.Canceled')
              }}</span>
              <span v-else-if="row.Status == '1'">{{
                $t('HistoricalRedemptionRecords.Submitted')
              }}</span>
              <span v-else-if="row.Status == '2'">{{
                $t('HistoricalRedemptionRecords.Processing')
              }}</span>
              <span v-else-if="row.Status == '3'">{{
                $t('HistoricalRedemptionRecords.Finished')
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="TrackingNum"
            :label="$t('HistoricalRedemptionRecords.CourierNumber')"
            width="150"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="strIsSend"
            :label="$t('HistoricalRedemptionRecords.DeliveredOrNot')"
            :width="lang == 'zh' ? '80' : '140'"
            show-overflow-tooltip
          >
            <template #default="{ row }">
              <span v-if="row.CommodityType != 1">{{ row.strIsSend }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="Remark"
            :label="$t('HistoricalRedemptionRecords.Note')"
            width="150"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="action"
            :label="$t('HistoricalRedemptionRecords.Operate')"
            width="130"
            fixed="right"
          >
            <template #default="{ row }">
              <el-button
                v-if="row.CommodityType != 1 && row.TrackingNum"
                type="text"
                @click="viewLogistic(row)"
                >{{
                  $t('HistoricalRedemptionRecords.logisticsInformation')
                }}</el-button
              >
              <el-button
                v-if="row.Status == 3 && row.IsEvaluation == 0"
                type="text"
                @click="handleRate(row)"
                >{{ $t('HistoricalRedemptionRecords.Evaluation') }}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          v-show="tableData && tableData.length"
          style="text-align: right"
          background
          layout="prev, pager, next"
          :current-page="pageInfo.page"
          :page-size="pageInfo.pageSize"
          :total="pageInfo.total"
          @current-change="currentPageChange"
        >
        </el-pagination>
      </div>
      <evaluation-modal ref="EvaluationModal" @refreshList="search()" />
      <!-- :orderInfo="item"
        :orderNo="item.orderNo"
        :orderId="item.orderId"
        :storeCode="item.storeCode" -->
      <logistics-info ref="LogisticsInfo" />
    </div>
  </page-view>
</template>
<script>
import { PageView } from '@/components'
import LogisticsInfo from './components/logisticsInfo'
import EvaluationModal from './components/evaluationModal'
import constants from '@/constants'
import { getOrdersPageListJson } from '@/api/pointsMall'
import { HttpResponseCode } from '@/utils/request'
import { USER_INFO } from '@/store/mutation-types'
import moment from 'moment'

export default {
  name: 'InvoiceSearch',
  components: { PageView, LogisticsInfo, EvaluationModal },
  data() {
    return {
      moment,
      searchForm: {},
      pageLoading: false,
      tableData: [],
      pageInfo: {
        pageSize: 10,
        page: 1,
        total: 0
      },
      lang: 'zh'
    }
  },
  computed: {
    userInfo() {
      return this.$ls.get(USER_INFO) || {}
    },
  },
  created() {
    this.search(true)
    this.lang = this.$ls.get('lang');
  },
  methods: {
    currentPageChange(value) {
      console.log(value)
      this.pageInfo.page = value
      this.search()
    },
    async search(isRefresh = false) {
      if (this.pageLoading) {
        return
      }
      this.pageLoading = true
      if (isRefresh) {
        this.pageInfo.page = 1
      }
      const queryData = {
        CustomerID: this.userInfo.CACode,
        ...this.searchForm,
        CommodityLanguageType: this.$ls.get('lang') == 'zh' ? 0 : 1,
        Pagesize: this.pageInfo.pageSize,
        PageIndex: this.pageInfo.page
      }
      await getOrdersPageListJson(queryData).then(res => {
        if (res && res.code == 200) {
          this.tableData = [...res.rows]
          this.pageInfo.total = res.total || this.tableData.length || 0
        }
        this.pageLoading = false
      }).catch(() => {
        this.pageLoading = false
      })
    },
    reset() {
      this.searchForm = {
        officeCode: '',
        invType: '',
        taxInvType: '',
        bpayed: '',
        payableDateBegin: '',
        payableDateEnd: ''
      }
      this.search(true)
    },
    viewLogistic(record) {
      this.$refs.LogisticsInfo.getLogistics(record)
    },
    handleRate(record) {
      this.$refs.EvaluationModal.handleOrderRatedModal(true, record)
    },
  }
}
</script>
<style lang="less">
.page-invoice-search {
  padding: 10px;
  background: #f0f6fb;
  .order-search {
    background: white;
    border-radius: 4px;
    padding: 16px 20px;
  }
  .title {
    font-size: 16px;
    font-weight: 600;
    color: #111827;
    line-height: 22px;
    margin-bottom: 20px;
  }
  .order-list {
    background: white;
    margin-top: 10px;
    border-radius: 4px;
    padding: 16px 20px;
    min-height: 60vh;
    .list-item {
      margin-bottom: 8px;
    }
  }
  .note-container {
    margin-top: 14px;
    line-height: 20px;
    .title {
      margin-bottom: 2px;
    }
  }
  .el-col.el-col-8 {
    padding: 0 !important;
  }
}
</style>
